export class Util {

    static isNullOrEmptyOrUndefined(objeto): boolean {
        return (objeto === null) || (objeto === 'null') || (objeto === undefined) || (objeto === '');
    }

    static calculaDiferencaDias(dataPosterior, dataAnterior): number {
        const timeDiff = Math.abs(dataPosterior.getTime() - dataAnterior.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    static retiraCaracteresEspeciais(texto) {
        if (Util.isNullOrEmptyOrUndefined(texto)) {
            return '';
        }
        return texto.replace(/[^0-9]/g, '');
    }

    static limpaCpf (cpf: string): string {
        if (Util.isNullOrEmptyOrUndefined(cpf)) {
            return '';
        }
        return cpf.replace(/[^0-9]/g, '');
    }
    static formatAsCpf(cnpjLimpo) {
        if (Util.isNullOrEmptyOrUndefined(cnpjLimpo)) {
            return '';
        }
        return cnpjLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    static isCpf(cpf: string): boolean {
        if (Util.isNullOrEmptyOrUndefined(cpf)) {
            return false;
        }

        cpf = cpf.replace(/[^\d]+/g, '');

        if (cpf.length !== 11) {
            return false;
        }

        let soma;
        let resto;
        soma = 0;
        if (cpf === '00000000000') {
            return false;
        }
        // Verifica se todos os números são iguais (caso inválido)
        if (/^(\d)\1+$/.test(cpf)) {
            return false;
        }

        for (let i = 1; i <= 9; i++) {
            soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
        }
        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }
        if (resto !== parseInt(cpf.substring(9, 10), 10) ) {
            return false;
        }

        soma = 0;
        for (let i = 1; i <= 10; i++) {
            soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
        }
        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }

        if (resto !== parseInt(cpf.substring(10, 11), 10) ) {
            return false;
        }

        return true;
    }

    static limpaCnpj (cnpj: string): string {
        if (Util.isNullOrEmptyOrUndefined(cnpj)) {
            return '';
        }
        return cnpj.replace(/[^0-9]/g, '');
    }
    static formatAsCnpj(cpfLimpo) {
        if (Util.isNullOrEmptyOrUndefined(cpfLimpo)) {
            return '';
        }
        return cpfLimpo.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    static isCnpj(cnpj: string): boolean {
        if (Util.isNullOrEmptyOrUndefined(cnpj)) {
            return false;
        }

        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj.length !== 14) {
            return false;
        }
        // Verifica se todos os números são iguais (caso inválido)
        if (/^(\d)\1+$/.test(cnpj)) {
            return false;
        }
        // Elimina CNPJs invalidos conhecidos
        if (
            cnpj === '00000000000000' ||  cnpj === '11111111111111' ||  cnpj === '22222222222222' ||
            cnpj === '33333333333333' ||  cnpj === '44444444444444' ||  cnpj === '55555555555555' ||
            cnpj === '66666666666666' ||  cnpj === '77777777777777' ||  cnpj === '88888888888888' ||
            cnpj === '99999999999999'
        ) {
            return false;
        }

        // Valida DVs
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        const digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += +numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) {
            pos = 9;
            }
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== +digitos.charAt(0)) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += +numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) {
            pos = 9;
            }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== +digitos.charAt(1)) {
            return false;
        }

        return true;
    }

    static limpaCep (cep: string): string {
        if (Util.isNullOrEmptyOrUndefined(cep)) {
            return '';
        }
        return cep.replace(/[^0-9]/g, '');
    }
    static formatAsCep(cepLimpo) {
        if (Util.isNullOrEmptyOrUndefined(cepLimpo)) {
            return '';
        }
        return cepLimpo.replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2-$3');
    }
    static isCep(cep: string) {
        if (Util.isNullOrEmptyOrUndefined(cep)) {
            return false;
        }

        cep = cep.replace(/[^\d]+/g, '');
        if (cep.length !== 8) {
            return false;
        }

        const exp = /^[0-9]{8}$/;
        if (!exp.test(cep)) {
            return false;
        }

        return true;
    }

    static isTelefone(telefone: string) {
        if (Util.isNullOrEmptyOrUndefined(telefone)) {
            return false;
        }

        const exp1 = /\(\d{2}\)\ \d{4}\-\d{4}/;
        const exp2 = /\(\d{2}\)\ \d{5}\-\d{4}/;
        const exp5 = /\(\d{2}\)\d{4}\-\d{4}/;
        const exp6 = /\(\d{2}\)\d{5}\-\d{4}/;
        const exp7 = /\(\d{2}\)\ \d{8}/;
        const exp8 = /\(\d{2}\)\ \d{9}/;
        const exp9 = /\(\d{2}\)\d{8}/;
        const exp10 = /\(\d{2}\)\d{9}/;
        const exp3 = /^[0-9]{10}$/;
        const exp4 = /^[0-9]{11}$/;
        if (
            !exp1.test(telefone) && !exp2.test(telefone)
            && !exp3.test(telefone) && !exp4.test(telefone)
            && !exp5.test(telefone) && !exp6.test(telefone)
            && !exp7.test(telefone) && !exp8.test(telefone)
            && !exp9.test(telefone) && !exp10.test(telefone)
        ) {
            return false;
        }

        const telefoneLimpo = telefone.replace(/[^\d]+/g, '');
        if (telefoneLimpo.length !== 10 && telefoneLimpo.length !== 11) {
            return false;
        }

        return true;
    }

    /**
     * Valida se a data de emissão da CNH atende aos requisitos mínimos para progressão de categoria
     * @param dataEmissaoCnh Data de emissão da CNH atual
     * @param categoriaAtual Categoria atual da CNH (B, C, D)
     * @param categoriaPretendida Categoria pretendida (C, D, E)
     * @returns true se atende aos requisitos, false caso contrário
     */
    static validaCnhProgressaoCategoria(dataEmissaoCnh: string, categoriaAtual: string, categoriaPretendida: string): boolean {
        if (Util.isNullOrEmptyOrUndefined(dataEmissaoCnh) ||
            Util.isNullOrEmptyOrUndefined(categoriaAtual) ||
            Util.isNullOrEmptyOrUndefined(categoriaPretendida)) {
            return false;
        }

        const dataEmissao = new Date(dataEmissaoCnh);
        const dataAtual = new Date();

        // Calcula a diferença em meses
        const mesesDiferenca = (dataAtual.getFullYear() - dataEmissao.getFullYear()) * 12 +
                              (dataAtual.getMonth() - dataEmissao.getMonth());

        // Define os tempos mínimos conforme as regras do CONTRAN
        const regrasProgressao = {
            'B-C': 12,  // De B para C: mínimo de 12 meses
            'B-D': 24,  // De B para D: mínimo de 24 meses
            'C-D': 12,  // De C para D: mínimo de 12 meses
            'D-E': 12,  // De D para E: mínimo de 12 meses
            'C-E': 12   // De C para E: mínimo de 12 meses
        };

        const chaveRegra = `${categoriaAtual}-${categoriaPretendida}`;
        const tempoMinimoMeses = regrasProgressao[chaveRegra];

        if (tempoMinimoMeses === undefined) {
            // Progressão não permitida ou não definida
            return false;
        }

        return mesesDiferenca >= tempoMinimoMeses;
    }

    static getAllUfs(){
        return [
      {label: 'Acre', value: 'AC'},
      {label: 'Alagoas', value: 'AL'},
      {label: 'Amapá', value: 'AP'},
      {label: 'Amazonas', value: 'AM'},
      {label: 'Bahia', value: 'BA'},
      {label: 'Ceará', value: 'CE'},
      {label: 'Distrito Federal', value: 'DF'},
      {label: 'Espírito Santo', value: 'ES'},
      {label: 'Goiás', value: 'GO'},
      {label: 'Maranhão', value: 'MA'},
      {label: 'Mato Grosso', value: 'MT'},
      {label: 'Mato Grosso do Sul', value: 'MS'},
      {label: 'Minas Gerais', value: 'MG'},
      {label: 'Pará', value: 'PA'},
      {label: 'Paraíba', value: 'PB'},
      {label: 'Paraná', value: 'PR'},
      {label: 'Pernambuco', value: 'PE'},
      {label: 'Piauí', value: 'PI'},
      {label: 'Rio de Janeiro', value: 'RJ'},
      {label: 'Rio Grande do Norte', value: 'RN'},
      {label: 'Rio Grande do Sul', value: 'RS'},
      {label: 'Rondônia', value: 'RO'},
      {label: 'Roraima', value: 'RR'},
      {label: 'Santa Catarina', value: 'SC'},
      {label: 'São Paulo', value: 'SP'},
      {label: 'Sergipe', value: 'SE'},
      {label: 'Tocantins', value: 'TO'}
    ];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/util.ts